import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { SEO } from "@/components/SEO";
import { BUSINESS } from "@/data/business";

const NotFound = () => (
  <>
    <SEO
      title="Page Not Found | Plush Spa"
      description="The page you're looking for doesn't exist. Return to Plush Spa's home page."
      path="/404"
    />
    <section className="min-h-[70vh] flex flex-col items-center justify-center text-center px-5 pt-20 bg-plush-bg">
      <p className="font-heading text-6xl font-bold text-plush-gold">404</p>
      <h1 className="font-heading text-3xl font-bold text-plush-text mt-4">
        This page has wandered off
      </h1>
      <p className="text-plush-textMuted mt-3 max-w-sm">
        Let's get you back to a calmer place.
      </p>
      <div className="flex flex-wrap justify-center gap-4 mt-8">
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="bg-plush-gold text-plush-bg px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-plush-goldHover transition-all"
        >
          Back Home
        </Link>
        <a
          href={`tel:${BUSINESS.phoneClean}`}
          data-testid="notfound-call-button"
          className="flex items-center gap-2 border border-plush-gold/25 text-plush-text px-7 py-3.5 rounded-full text-sm font-medium hover:bg-plush-surface transition-all"
        >
          <Phone className="w-4 h-4" /> Call Us
        </a>
      </div>
    </section>
  </>
);

export default NotFound;
